import { inch_to_pixel } from "values/values";
import { SLAB_ZOOM } from "values/values";

export function getCanvasHeight(slab_height: number, slab_number: number): number {
  return 50 + slab_number * slab_height * SLAB_ZOOM * inch_to_pixel + slab_number * 25 + 100;
}
